import { Injectable } from '@angular/core';
import { IContactDto } from '@shared/interfaces/user/IContactDto';
import { ApiService } from '@shared/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class ContactService {
    constructor(private apiService: ApiService) {}

    public async getContactPersonInfo(): Promise<IContactDto> {
        return this.apiService.get('/contact');
    }
}
